import {
  CLONE_GROUP_SETTINGS_REQUEST_ASYNC,
  DELETE_GROUP_SETTINGS_REQUEST_ASYNC,
  FILTERS_CHANGE,
  FILTERS_CLEAR,
  FILTERS_SUBMIT,
  GROUP_SETTINGS_DATA_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC,
  SORT_PROPERTY_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    data: {
      items: [],
    },
    error: null,
    loader: false,
    tableLoader: false,
    page: 1,
    search: '',
    sortProperty: '', // first_name-desc
    filters: {
      assignedFilter: '',
      updatedByFilter: [],
      lastUpdatedFilter: '',
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          tableLoader: true,
          page: 1,
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          tableLoader: true,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page || 1,
          tableLoader: true,
        }
      case FILTERS_SUBMIT:
        return { ...state, tableLoader: true }
      case FILTERS_CHANGE:
        return {
          ...state,
          filters: {
            ...state.filters,
            [action.payload.filterType]: action.payload.value,
          },
        }
      case FILTERS_CLEAR:
        return {
          ...state,
          filters: {
            assignedFilter: '',
            updatedByFilter: [],
            lastUpdatedFilter: '',
          },
        }
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case CLONE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE:
      case DELETE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE:
      case SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          tableLoader: true,
          error: null,
        }
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
          tableLoader: false,
        }
      case CLONE_GROUP_SETTINGS_REQUEST_ASYNC.ERROR:
      case DELETE_GROUP_SETTINGS_REQUEST_ASYNC.ERROR:
      case SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.ERROR:
        return { ...state, tableLoader: false }
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CLONE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL:
      case DELETE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL:
      case SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.CANCEL:
        return { ...state, tableLoader: false, page: 1 }
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false, page: 1 }
      default:
        return state
    }
  }
}
